import { deviceID } from "../../state";

// Fallback used only until the licence response (which carries the real
// proxy_url) has been fetched and cached at least once.
const DEFAULT_PROXY_URL = "https://proxy1.orbixplay.com/";

export function getProxyUrl(): string {
  return localStorage.getItem("proxy_url") || DEFAULT_PROXY_URL;
}

// "clientArea" playlists carry a playlistownerId that identifies the reseller
// account owning the playlist; "orbixplayweb" playlists don't, so orbix_id is "null".
function computeOrbixId(): string {
  try {
    const raw = localStorage.getItem("licenceData");
    if (!raw) return "null";

    const licence = JSON.parse(raw);
    const playlists = Array.isArray(licence?.playlists) ? licence.playlists : [];

    const ownerIds = Array.from(
      new Set(
        playlists
          .filter((p: any) => p?.source === "clientArea" && p?.playlistownerId)
          .map((p: any) => String(p.playlistownerId)),
      ),
    );

    return ownerIds.length > 0 ? ownerIds.join(",") : "null";
  } catch {
    return "null";
  }
}

export function getProxyHeaders(): Record<string, string> {
  return {
    mac_address: deviceID() || "",
    orbix_id: computeOrbixId(),
    device_brand: "lg",
  };
}
